import { createSlice } from '@reduxjs/toolkit';
import { pageModel } from '../../utils/model';

const initialState = {
    page: pageModel
}

const patternSlice = createSlice({
    name: 'pattern',
    initialState,
    reducers: {
        setPatternPageAction: (state, action) => {
            state.page = action.payload
        },
        getPatternPageAction: (state, action) => {
            const content = state.page.content.concat(action.payload.content)
            state.page = { ...action.payload, content }
        },
        addPatternAction: (state, action) => {
            state.page.content.unshift(action.payload)
        },
        updatePatternAction: (state, action) => {
            const content = state.page.content.map((pattern) => {
                if (pattern.id === action.payload.id) return action.payload
                else return pattern
            })
            state.page.content = content
        },
        deletePatternAction: (state, action) => {
            const content = state.page.content.filter(p => p.id !== action.payload)
            state.page.content = content
        },
        uploadPatternExcelFileAction: (state, action) => {
            let content = [...action.payload.reverse(), ...state.page.content]
            state.page.content = content
            // state.page.content = content
        }
    },
});

export const { setPatternPageAction, getPatternPageAction, addPatternAction, updatePatternAction, deletePatternAction, uploadPatternExcelFileAction } = patternSlice.actions;
export default patternSlice;